module.exports = __webpack_public_path__ + "media/images/sites/health/f-responsivo-74374f8a7580e99be8964ec1aaecbf3d.jpg";